import config from "config/appConfig";

import type { IStateProps } from "utils/StateOf";
import createStore from "utils/createStore";

import type { DBChatMessage, DBChatModel } from "../../types/Messages";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.MESSAGING_DATA}`;

export interface Values {
	loadingConversations: boolean;
	conversationsListNextToken?: string;

	currentConversation?: DBChatModel;

	deleteMessageDialog?: {
		open: boolean;
		message?: DBChatMessage;
	};
	deletingMessage: boolean;

	editMessage?: DBChatMessage;
}

export const initialState: IStateProps<Values> = {
	loadingConversations: false,
	conversationsListNextToken: undefined,

	currentConversation: undefined,

	deleteMessageDialog: undefined,
	deletingMessage: false,

	editMessage: undefined
};

export default createStore<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
